/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SIP } from './SIP';
import {
    SIPFromJSON,
    SIPFromJSONTyped,
    SIPToJSON,
} from './SIP';

/**
 * 
 * @export
 * @interface ListTransferSipsResponseBody
 */
export interface ListTransferSipsResponseBody {
    /**
     * 
     * @type {Array<SIP>}
     * @memberof ListTransferSipsResponseBody
     */
    items: Array<SIP>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListTransferSipsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListTransferSipsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListTransferSipsResponseBody interface.
 */
export function instanceOfListTransferSipsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListTransferSipsResponseBodyFromJSON(json: any): ListTransferSipsResponseBody {
    return ListTransferSipsResponseBodyFromJSONTyped(json, false);
}

export function ListTransferSipsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTransferSipsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SIPFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListTransferSipsResponseBodyToJSON(value?: ListTransferSipsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SIPToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

